import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAssetPreload } from '../hooks/useAssetPreload';
import { PageRouter } from '../pages/pageRouter';
import { GlobalStylesComponent } from '../styles/globalStylesComponent';
import { darkTheme } from '../styles/materialTheme';
import { BugsnagErrorBoundaryContainer } from './errorBoundary/bugsnagErrorBoundaryContainer';
import { NamedVersionDevHeaderContainer } from './namedVersionDevHeaderContainer';
const queryClient = new QueryClient();
export const AppTop = () => {
    useAssetPreload();
    return (_jsx(BugsnagErrorBoundaryContainer, { children: _jsxs(QueryClientProvider, { client: queryClient, children: [_jsx(GlobalStylesComponent, {}), _jsx(StyledEngineProvider, { injectFirst: true, children: _jsx(ThemeProvider, { theme: darkTheme, children: _jsx(PageRouter, {}) }) }), _jsx(NamedVersionDevHeaderContainer, {})] }) }));
};
